import { forwardRef, useEffect, useContext } from "react"
import { Password } from 'primereact/password';
import { Divider } from 'primereact/divider';
import { Declaration } from "./declaration";
import { InputText } from 'primereact/inputtext';
import { loadCaptchaEnginge, LoadCanvasTemplate } from 'react-simple-captcha';
import { AddressContext } from "../contexts/AddressContext";
import { AuthContext } from "../contexts/AuthContext";

export const AdditionalInfo = forwardRef(({ formData, handleChange, isMunicipality, onBlurValidate }, ref) => {

    let lengthValid = formData.password.length > 5;
    let lowecaseValid = /[a-z]/.test(formData.password);
    let uppercaseValid = /[A-Z]/.test(formData.password);
    let numberValid = /\d/.test(formData.password);

    const { parentEgnExist } = useContext(AddressContext)
    const { user } = useContext(AuthContext)

   /* useEffect(() => {
        if (!isMunicipality) {
            loadCaptchaEnginge(6);
        }
    }, []);*/

    const header = <div className="font-bold mb-3">Сигурност на паролата</div>;
    const footer = (
        <>
            <Divider />
            <p className="mt-2">Изисквания</p>
            <ul className="pl-2 ml-2 mt-0 line-height-3 pass-list-style">
                <li className={lengthValid ? 'pass-list-item' : 'fail-list-item'}>Минимум 6 символа</li>
                <li className={lowecaseValid ? 'pass-list-item' : 'fail-list-item'}>Поне една малка буква</li>
                <li className={uppercaseValid ? 'pass-list-item' : 'fail-list-item'}>Поне една главна буква</li>
                <li className={numberValid ? 'pass-list-item' : 'fail-list-item'}>Поне една цифра</li>
            </ul>
        </>
    );



    //pass-list-item; fail-list-item

    return (
        <>
            <div ref={ref} className="htext_ch">Парола и правила</div>
            {(!parentEgnExist && user.role != 'Parent') &&
                <div className="children_data d-flex flex-wrap flex-col gap-1 mb-2 p-3-mob w-100-mob">
                    <span className="p-float-label">
                        <Password
                            inputId="pass"
                            name='password'
                            value={formData.password}
                            onChange={handleChange}
                            onBlur={onBlurValidate}
                            header={header}
                            footer={footer}
                            toggleMask
                            className={!lengthValid || !lowecaseValid || !uppercaseValid || !numberValid ? 'p-invalid' : ''}
                        />
                        <label htmlFor="pass">Парола</label>
                    </span>
                </div>
            }
            <div className="children_data d-flex flex-wrap mb-2 p-3-mob">
                <Declaration formData={formData} handleChange={handleChange} />
            </div>

            
        </>
    )
})